// LIST
export const FETCH_HOME_GROUP_ADMINS =
  "app/HomeGroupsAdmin/FETCH_HOME_GROUP_ADMINS";
export const FETCH_HOME_GROUP_ADMINS_SUCCESS =
  "app/HomeGroupsAdmin/FETCH_HOME_GROUP_ADMINS_SUCCESS";
export const FETCH_HOME_GROUP_ADMINS_FAILURE =
  "app/HomeGroupsAdmin/FETCH_HOME_GROUP_ADMINS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/HomeGroupsAdmin/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS =
  "app/HomeGroupsAdmin/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE =
  "app/HomeGroupsAdmin/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_HOME_GROUP_ADMIN = "app/HomeGroupsAdmin/ADD_HOME_GROUP_ADMIN";
export const ADD_HOME_GROUP_ADMIN_SUCCESS =
  "app/HomeGroupsAdmin/ADD_HOME_GROUP_ADMIN_SUCCESS";
export const ADD_HOME_GROUP_ADMIN_FAILURE =
  "app/HomeGroupsAdmin/ADD_HOME_GROUP_ADMIN_FAILURE";
// EDIT
export const EDIT_HOME_GROUP_ADMIN =
  "app/HomeGroupsAdmin/EDIT_HOME_GROUP_ADMIN";
export const EDIT_HOME_GROUP_ADMIN_SUCCESS =
  "app/HomeGroupsAdmin/EDIT_HOME_GROUP_ADMIN_SUCCESS";
export const EDIT_HOME_GROUP_ADMIN_FAILURE =
  "app/HomeGroupsAdmin/EDIT_HOME_GROUP_ADMIN_FAILURE";
// DELETE
export const DELETE_HOME_GROUP_ADMIN =
  "app/HomeGroupsAdmin/DELETE_HOME_GROUP_ADMIN";
export const DELETE_HOME_GROUP_ADMIN_SUCCESS =
  "app/HomeGroupsAdmin/DELETE_HOME_GROUP_ADMIN_SUCCESS";
export const DELETE_HOME_GROUP_ADMIN_FAILURE =
  "app/HomeGroupsAdmin/DELETE_HOME_GROUP_ADMIN_FAILURE";
//
export const OPEN_ADMIN_ADD_MODAL = "app/HomeGroupsAdmin/OPEN_ADMIN_ADD_MODAL";
export const CLOSE_ADMIN_ADD_MODAL =
  "app/HomeGroupsAdmin/CLOSE_ADMIN_ADD_MODAL";
//
export const OPEN_ADMIN_EDIT_MODAL =
  "app/HomeGroupsAdmin/OPEN_ADMIN_EDIT_MODAL";
export const CLOSE_ADMIN_EDIT_MODAL =
  "app/HomeGroupsAdmin/CLOSE_ADMIN_EDIT_MODAL";

export const INVITE_ADMIN = "app/HomeGroupsAdmin/INVITE_ADMIN";
export const INVITE_ADMIN_SUCCESS = "app/HomeGroupsAdmin/INVITE_ADMIN_SUCCESS";
export const INVITE_ADMIN_FAILURE = "app/HomeGroupsAdmin/INVITE_ADMIN_FAILURE";

export const GET_USER_LIST = "app/HomeGroupsAdmin/GET_USER_LIST";
export const GET_USER_LIST_SUCCESS =
  "app/HomeGroupsAdmin/GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_FAILURE =
  "app/HomeGroupsAdmin/GET_USER_LIST_FAILURE";
